"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecatedMsg = void 0;
var deprecatedMsg = function (msg) {
    if (process.env.NODE_ENV === 'development') {
        // tslint:disable-next-line:no-console
        console.log("%c Deprecated:%c ".concat(msg), 'background: #fac249; color: #000; font-weight: bold', '');
    }
};
exports.deprecatedMsg = deprecatedMsg;
//# sourceMappingURL=index.js.map